export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Premium Bank",
  headline: "Unlimited Transactions with zero fees",
  description:
    "Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-1.svg").default,
  alt: "relevant image",
  primary: true,
  dark: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Unlimited Access",
  headline: "Login to your account at any time",
  description: "We have you covered no matter where you are located.",
  buttonLabel: "Learn More",
  imgStart: true,
  img: require("../../images/svg-2.svg").default,
  alt: "relevant image",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Join our Team",
  headline: "Creating an account is extremely easy",
  description: "Get everything set up and ready in under 10 minutes.",
  buttonLabel: "Start Now",
  imgStart: false,
  img: require("../../images/svg-3.svg").default,
  alt: "relevant image",
  primary: false,
  dark: false,
  darkText: true,
};
